import * as goldenrush from './Slogan.styles.goldenrush';
import * as juicybet from './Slogan.styles.juicybet';
import * as puntcity from './Slogan.styles.puntcity';
import * as sterlingparker from './Slogan.styles.sterlingparker';
import * as vikingbet from './Slogan.styles.vikingbet';
import * as forsport from './Slogan.styles.forsport';
import * as junglebet from './Slogan.styles.junglebet';
import * as oldgill from './Slogan.styles.oldgill';
import * as sugarcastle from './Slogan.styles.sugarcastle';
import * as buffalobet from './Slogan.styles.buffalobet';
import * as titanbet from './Slogan.styles.titanbet';
import * as bet777 from './Slogan.styles.bet777';
import * as gigabet from './Slogan.styles.gigabet';
import * as slambet from './Slogan.styles.slambet';
import * as betstride from './Slogan.styles.betstride';
import * as templebet from './Slogan.styles.templebet';
import * as goldenbet888 from './Slogan.styles.goldenbet888';
import * as hyperbet from './Slogan.styles.hyperbet';
import * as chromabet from './Slogan.styles.chromabet';
import * as bet575 from './Slogan.styles.bet575';
import * as epicodds from './Slogan.styles.epicodds';
import * as pyramidbet from './Slogan.styles.pyramidbet';
import * as magnumbet from './Slogan.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  juicybet,
  puntcity,
  sterlingparker,
  vikingbet,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  bet777,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
